export const roundNumber = (number: Nullable<number | undefined>, fractionDigits = 2): number => {
  return number ? Number(number.toFixed(fractionDigits)) : 0;
};
